import React, { Component } from "react";
import { formBuilderGroups } from "../../../variables/formBuilderData";
import Collapsible from "react-collapsible";
import { checkTranslation, translate } from "../../../utils/useful";

class ExistingForms extends Component {
    state = {
        closedGroups: {},
        showChildsSide: false
    };
    onDragStart = (e, rowId, type) => {
        let dataObject = { rowId, type, dropType: "NEW" };
        if (e.dataTransfer.setData) {
            e.dataTransfer.setData(
                "dragData",
                JSON.stringify(dataObject)
            );
        } else {
            e.dataTransfer.rowId = rowId;
            e.dataTransfer.type = type;
        }
        this.props.showhandlers();
    };


    toggleOpen = (key) => {
        let closedGroups = this.state.closedGroups
        closedGroups[key] = closedGroups[key] == null ? true : !closedGroups[key]
        this.setState({ closedGroups })
    }

    render() {
        const { formItems, hideHandlers } = this.props;

        return (
            <div className="column-forms-holder mt-2 ">
                {/* <div className="w-100 px-3 pb-3 pt-3 mb-3 flexc" style={{ backgroundColor: '#00000010' }}>
                    <div className="flexc">

                        <div className='mrd-2 flexcc'>
                            <button onClick={() => { this.props.lastStage(); this.props.lastStagePage() }} className='px-1 py-1  flexcc' style={{ filter: 'saturate(20%) ', background: 'linear-gradient(to right, #9564FE, #7064FE)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>

                                <div className='flexcc rotate-180 p-1' style={{ borderRadius: 10 }}>
                                    <img className='invert rtl-button' src='/assets/icons/angle-right.svg' height={18} />
                                </div>
                            </button>
                        </div>

                       
                    </div>

                    <button onClick={() => { this.props.onSave() }} className='px-1 py-1  flexcc ' style={{ filter: !this.state.type == null ? 'saturate(20%) ' : '', background: 'linear-gradient(to right,#9564FE, #7064FE)', borderRadius: 8, color: '#fff', transition: 'all 0.5s' }}>
                        <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{checkTranslation(this.props.saveTitle)}</p>
                        <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                            <img className='invert' src='/assets/icons/useful/save.svg' height={18} />
                        </div>
                    </button>
                </div> */}
                {/* <div className="px-3">
                    <p className="text-semibold font-size-16">{translate("Drag fields in to the form")}</p>
                </div> */}
                <div className=" pt-2 mt-1">

                    {Object.values(formBuilderGroups).map((group, index) => {
                        return (

                            <div className="mb-3 pb-2 px-2 w-100" style={{ borderBottom: '1px solid #eee' }} key={group.key}>
                                <button className="p-0 px-2 mb-2 flexcb w-100" onClick={() => this.toggleOpen(group.key)} >
                                    <div className="text-start">
                                        <p className="text-semibold font-size-15 ">{checkTranslation(group.title)}</p>
                                        {/* <p className="text-smallest " style={{color:'#9ab'}}>This is the description of this section</p> */}
                                    </div>
                                    <img className={"mld-2 transition opacity-2 " + (!this.state.closedGroups[group.key] ? 'rotate-90' : '')} src={'/images/nexts.png'} width="13px" alt="" />
                                </button>

                                <Collapsible Collapsible open={!this.state.closedGroups[group.key]
                                } transitionTime={100} >
                                    <div className="d-flex mb-2" style={{ flexWrap: 'wrap', alignItems: "stretch" }}>

                                        {formItems.map((formItem, index) => {
                                            if (this.props?.page) {
                                                if (formItem?.used?.includes(this.props.page)) {
                                                    if (formItem.parent === group.key && !formItem.hideInFormBuilder)
                                                        return (
                                                            <div key={index} className=" p-1 mb-0 px-1 flex-1" style={{ width: '50%',flexBasis:'50%',maxWidth:'50%' }} key={formItem.type}>
                                                                <div
                                                                    key={index}
                                                                    className="form-item flexcc flex-column text-smaller pt-2 pb-2 flex-1"
                                                                    onDragStart={(e) =>
                                                                        this.onDragStart(e, index, formItem.type)
                                                                    }
                                                                    onDragEnd={hideHandlers}
                                                                    // onDragLeave={hideHandlers}
                                                                    draggable
                                                                >
                                                                    <img draggable={false} src={formItem.icon} height={30} />
                                                                    <p draggable={false} className="mt-2 text-semibold text-center">{checkTranslation(formItem.label)}</p>
                                                                </div>
                                                            </div>
                                                        );
                                                }
                                            }
                                            else {
                                                if (formItem.parent === group.key && !formItem.hideInFormBuilder)
                                                    return (
                                                        <div key={index}  className=" p-1 mb-0 flex-1" style={{ width: '50%',flexBasis:'50%',maxWidth:'50%' }} key={formItem.type}>
                                                            <div key={index} className="form-item flexcc flex-column text-smaller pt-2 pb-2 px-1 h-100" onDragStart={(e) => this.onDragStart(e, index, formItem.type)} onDragEnd={hideHandlers} draggable>
                                                                <img draggable={false} src={formItem.icon} height={30} />
                                                                <p draggable={false} className="mt-2 text-semibold text-center">{checkTranslation(formItem.label)}</p>
                                                            </div>
                                                        </div>
                                                    );
                                            }

                                        }

                                        )}
                                    </div>
                                </Collapsible>
                            </div >
                        )
                    })}
                </div>
            </div >
        );
    }
}



export default ExistingForms;